import Vue from 'vue'

export const ReleasesService = {
  list (params = []) {
    return Vue.axios.get('/releasedocuments', { params })
      .then((response) => response.data)
  },

  create (params) {
    return Vue.axios.post('/releasedocuments', params)
      .then((response) => response.data)
  },

  delete (id) {
    return Vue.axios.delete(`/releasedocuments/${id}`)
  },

  item (id) {
    return Vue.axios.get(`/releasedocuments/${id}`)
  },

  update (id, data) {
    return Vue.axios.put(`/releasedocuments/${id}`, data)
  },

  submit (id) {
    return Vue.axios.post(`/releasedocuments/${id}/approve`)
      .then((response) => response.data)
  },
  attachmentList (id) {
    return Vue.axios.get(`/releasedocuments/${id}/attachments`)
        .then((response) => response)
  },

  download (params = []) {
    return Vue.axios.get('/releasedocuments/download',
      {
        params,
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.ms-excel' }
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'data.xlsx');
        document.body.appendChild(link);
        link.click();
      })
  }
}
